import React from 'react';
import ReactDOM from 'react-dom';
import Index from './pages/';

import 'babel-polyfill';


import './reset.less';
import './App.less';


module.exports = window.startApp = (data) => {
  ReactDOM.render(
    <Index data={data} />,
    document.getElementById('root')
  );
}



// WEBPACK FOOTER //
// ./src/index.js